let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a6OdX")).then(() => parcelRequire('7IrZa'));